import styled from "styled-components";


export const PopularCollectionItem = styled.div`
    width: 400px;
    height: 375px;
    background: ${({ theme }) => theme.newBg2};
    margin: 0 1rem;
    padding: 1rem;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &:hover {
        box-shadow: ${({ theme }) => theme.boxShadow};
        cursor: pointer;
    }
`;

export const PopularCollectionHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 64px;
    padding: 0 0.5rem;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;

    span {
        width: calc(100% - 164px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const PopularCollectionLikes = styled.div`
    height: 100%;
    width: 80px;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
`;

export const PopularCollectionLikeCount = styled.div`
    height: 32px;
    min-width: 64px;
    max-width: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: bold;
    z-index: 1;
    background: ${({ theme }) => theme.pageBg};
    border-radius: 0.5rem;
    margin: 0.5rem;

    > svg {
        margin-right: 5px;
        &:only-child {
            margin-right: 0;
        }
    }

    &.liked,
    &:hover {
        cursor: pointer;
        > svg {
            color: ${({ theme }) => theme.red2};
            font-size: 0.9rem;
        }
    }
`;

export const PopularCollectionImage = styled.div`
    width: 64px;
    height: 64px;
    border-radius: 1rem;
    position: relative;
    overflow: hidden;
    background: ${({ theme }) => theme.newBg3};
    margin-right: 10px;

    > img {
        max-height: 100%;
        max-width: 100%;
    }

    svg {
        width: 1.5rem;
        position: absolute;
        bottom: 0px;
        right: 0px;
        fill: rgb(32, 129, 226);
    }
`

export const PopularCollectionImages = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
`;

export const CollectionImageRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    margin: 5px 0;
`;

export const CollectionImageColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;
    margin: 0 5px;
`;

export const CollectionImageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: ${({ theme }) => theme.newBg3};
    width: 100%;
    height: 100%;
    border-radius: 1rem;
    
    > img {
        max-height: 100%;
        max-width: 100%;
    }

    &:hover {
        box-shadow: ${({ theme }) => theme.boxShadow};
        transform: scale(1.01);
    }
`;